import React from 'react';
import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import { CardMembership as PlanIcon } from '@mui/icons-material';

export type ActivePlanBadgeItem = {
  id?: string;
  plan_name?: string;
  days_remaining?: number;
  overdue_count?: number;
  charges_paid?: number;
  charges_total?: number;
};

/** Alias usado em Patients.tsx e na API de planos ativos. */
export type ActivePlan = ActivePlanBadgeItem;

type Props = {
  plans?: ActivePlanBadgeItem[] | null;
  variant?: 'chip' | 'dot';
};

const PatientPlanBadge: React.FC<Props> = ({ plans, variant = 'chip' }) => {
  const list = (plans || []).filter((p) => p?.plan_name);
  if (!list.length) return null;

  if (variant === 'dot') {
    const primary = list[0];
    const title = list.map((p) => p.plan_name).join(' · ');
    return (
      <Tooltip title={title}>
        <PlanIcon sx={{ fontSize: 14, color: '#0d9488', ml: 0.25, verticalAlign: 'middle' }} />
      </Tooltip>
    );
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 0.5 }}>
      {list.map((plan) => {
        const overdue = Number(plan.overdue_count) > 0;
        const label = plan.plan_name || 'Plano';
        const hint = [
          plan.days_remaining != null ? `${plan.days_remaining} dia(s) de vigência` : null,
          plan.charges_total != null ? `${plan.charges_paid || 0}/${plan.charges_total} parcelas pagas` : null,
        ].filter(Boolean).join(' · ');

        return (
          <Tooltip key={plan.id || label} title={hint || label}>
            <Chip
              size="small"
              icon={<PlanIcon sx={{ fontSize: '16px !important' }} />}
              label={(
                <Typography component="span" variant="caption" sx={{ fontWeight: 700 }}>
                  {label}
                </Typography>
              )}
              sx={{
                height: 22,
                bgcolor: overdue ? '#fef2f2' : '#ecfdf5',
                color: overdue ? '#b91c1c' : '#047857',
                border: '1px solid',
                borderColor: overdue ? '#fecaca' : '#a7f3d0',
              }}
            />
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default PatientPlanBadge;
